// extracted by mini-css-extract-plugin
module.exports = {"container":"Start_container__2hdFe","pulse":"Start_pulse__3vqjB"};